import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class EnvironmentService {
    private configObservable: Observable<any>;
    public config: BehaviorSubject<any> = new BehaviorSubject<any>(null);


    constructor() {
        this.config = new BehaviorSubject<any>(null);
        this.configObservable = this.config.asObservable();
    }

    extractSetting(env: any, args: string, defaultResponse: any) {

        if (env == null) {
            return defaultResponse;
        }
        let itm = { ...env };
        let theArgs = args.split('.');

        for (let i = 0; i < theArgs.length; i++) {

            if (itm.hasOwnProperty(theArgs[i])) {
                if (i == theArgs.length - 1) {
                    return itm[theArgs[i]] != null ? itm[theArgs[i]] : defaultResponse;
                }
                itm = itm[theArgs[i]];
            } else {
                return defaultResponse;
            }
        }
    }
}
